// Search in the key guide: the rows whose words or keys the query names.
import type { GuideRow, GuideSection } from './guide';

/** Words of `text`, lowercased: runs of letters and digits. */
const words = (text: string) => text.toLowerCase().match(/[\p{L}\p{N}]+/gu) ?? [];

/**
 * Whether `row` (in section `title`) answers `terms`: each term begins a
 * word of what it does, its note or its section's title, or is one of its
 * keys as written (`c`, `]c`, `go`), so a key can be looked up too.
 */
function answers(row: GuideRow, title: string, terms: string[]): boolean {
  const text = words(`${row.does} ${row.note ?? ''} ${title}`);
  const keys = row.keys.map((k) => k.toLowerCase().replace(/\s+\+\s+object$/, ''));
  return terms.every((t) => keys.includes(t) || text.some((w) => w.startsWith(t)));
}

/**
 * The guide's sections as `query` narrows them: each with only its rows
 * that answer every term (whitespace-separated, any case), and none left
 * empty. An empty query keeps everything.
 */
export function searchGuide(sections: readonly GuideSection[], query: string): GuideSection[] {
  const terms = query.toLowerCase().split(/\s+/).filter(Boolean);
  if (!terms.length) return [...sections];
  return sections.flatMap((s) => {
    const rows = s.rows.filter((r) => answers(r, s.title, terms));
    return rows.length ? [{ ...s, rows }] : [];
  });
}
